module.exports = __webpack_public_path__ + "img/shape-drop-secondary.45505607.svg";